<template>
  <div class="px-10 py-6 white">
    <div class="ShopInformation-card">
      <div class="ShopInformation-title">{{ $t('shopInformation.title') }}</div>
      <div>
        <v-row>
          <v-col cols="12" md="8" order="2" order-md="1">
            <v-col cols="12" lg="10" class="order-md-first">
              <TextFieldValidation
                v-model="form.displayName"
                name="nameName"
                rules="required"
                :label="`${$t('shopInformation.nameLabel')}*`"
              />
              <TextFieldValidation
                v-model="form.address1"
                name="addressName1"
                rules="required"
                :label="`${$t('shopInformation.address1Label')}*`"
              />
              <TextFieldValidation
                v-model="form.address2"
                name="addressName2"
                :label="$t('shopInformation.address2Label')"
              />
              <v-row>
                <v-col cols="6" md="4">
                  <TextFieldValidation
                    v-model="form.postalCode"
                    name="cpName"
                    :label="`${$t('shopInformation.cpLabel')}`"
                  />
                </v-col>
                <v-col cols="6" md="4">
                  <TextFieldValidation
                    v-model="form.city"
                    name="cityName"
                    rules="required"
                    :label="`${$t('shopInformation.cityLabel')}*`"
                  />
                </v-col>
              </v-row>
              <TextFieldValidation
                v-model="form.phoneNumber"
                name="phoneName"
                rules="required"
                :label="`${$t('shopInformation.phoneLabel')}*`"
              />
              <TextFieldValidation
                v-model="form.email"
                name="emailName"
                rules="required|email"
                :label="`${$t('shopInformation.emailLabel')}*`"
              />
            </v-col>
          </v-col>
          <v-col class="d-flex justify-end" order="1" order-md="2">
            <div class="ShopInformation-logoContainer">
              <AddLogo v-model="form.logo" :logoLink="form.logoLink" />
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import TextFieldValidation from '@/components/lib/inputValidation/textFieldValidation'
import AddLogo from '@/components/settings/AddLogo'
export default {
  name: 'ShopInformation',

  components: { AddLogo, TextFieldValidation },

  model: {
    prop: 'form',
    event: 'change'
  },

  props: {
    form: Object
  }
}
</script>

<style lang="scss">
.ShopInformation-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--v-secondary-base);
}

.ShopInformation-logoContainer {
  width: 112px;
  height: 112px;
}
</style>
